// extracted by mini-css-extract-plugin
export default {"iconButtonWrapper":"personalizedIconButton_iconButtonWrapper__jgFkD"};